import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ReactSlider from 'react-slider'
import HoldingsEditor from './HoldingsEditor/HoldingsEditor';
import {
  saveClient,
  setEditMode,
} from '../../actions/advisor';
import s from './Step3.css';
import './Slider.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faGripLinesVertical} from '@fortawesome/free-solid-svg-icons';

library.add(faChevronLeft, faChevronRight, faGripLinesVertical);

class Step3 extends PureComponent {

  constructor(props) {
    super(props);
    const newClient = Object.assign({}, this.props.client);
    this.state = {
      client: newClient,
      isDirty: false,
      holdingsEditorKey: Math.random(),
    };
    this.handleUpdateHoldings = this.handleUpdateHoldings.bind(this);
  }

  handleUpdateHoldings(holdings) {
    let formattedHoldings = [{
      tickers: holdings.map(holding => {
        return holding.ticker;
      }),
      weights: holdings.map(holding => {
        return holding.weight;
      })
    }];
    const newClient = Object.assign({}, this.state.client);
    newClient.holdings = formattedHoldings;
    this.setState(Object.assign({}, this.state, {
      client: newClient,
      isDirty: true,
    }));
  }

  handleUpdateBlend = (value) => {
    value = (10 - value) * 10 / 100;
    const newClient = Object.assign({}, this.state.client);
    newClient['modelBlendPct'] = value;
    this.setState(Object.assign({}, this.state, {
      client: newClient,
      isDirty: true,
    }));
  }

  // save client with current saved state values
  saveClient = (event) => {
    const {
      client,
    } = this.state;
    event.preventDefault();
    const newClient = Object.assign({}, this.props.client);
    newClient.expectedReturns = 0.0;
    newClient.expectedVolatility = 0.0;
    newClient.holdings = client.holdings;
    newClient.modelBlendPct = client.modelBlendPct;
    this.props.saveClient(newClient).then(() => {
      this.setState(Object.assign({}, this.state, {
        isDirty: false,
      }));
      this.props.closeStep();
    });
  }

  clearEditMode = (event) => {
    event.preventDefault();
    this.props.setEditMode('');
  }

  resetClient = (event) => {
    event.preventDefault();
    const newClient = Object.assign({}, this.props.client);
    this.setState(Object.assign({}, this.state, {
      client: newClient,
      isDirty: false,
      holdingsEditorKey: Math.random(),
    }));
  }

  render() {
    const {
      client,
      isDirty,
      holdingsEditorKey,
    } = this.state;

    const {
      token,
      advisorEmail,
    } = this.props;

    const params = {
      clientEmail: advisorEmail,
      token: token,
      client: client,
    }

    const typeaheadUrl = `${process.env.REACT_APP_DPD_URL}/api/securityfund/typeahead/`;
		const checkTickersUrl = `${process.env.REACT_APP_DPD_URL}/api/securityfund/ticker_names/`;

    return (
      <React.Fragment>
        <div className="row" style={{ marginTop: '30px' }}>
          <div className={`col-md-6`}>
            <div className={s.formTitle}>Enter {client.firstName}'s Current Portfolio</div>
          </div>
        </div>

        <div className={'row'} style={{ marginTop: '30px' }}>
          <div className='col-md-12'>
            <HoldingsEditor
              key={holdingsEditorKey}
              initialHoldings={client.holdings[client.holdings.length - 1]}
              params={params}
              typeaheadUrl={typeaheadUrl}
              checkTickersUrl={checkTickersUrl}
              updateHoldings={this.handleUpdateHoldings}
            //benchmarks={this.props.benchmarks}
            //totalValue={totalValue}
            />
          </div>
        </div>
        <div className={'row'}>
          <div className='col-md-12'>
            <div className={s.sliderTitle}>
            Use the slider tool to explore the impact of blending in different percentages of<br />
            WisdomTree Models while keeping a percentage of your client’s current portfolio intact.
            </div>
          </div>
        </div>
        <div className={'row'}>
          <div className='col-md-6'>
            <div className={'row'}>
              <div className={`col-md-6 ${s.sliderValLeft}`}>{100 - (client.modelBlendPct * 100)}%</div>
              <div className={`col-md-6 ${s.sliderValRight}`}>{client.modelBlendPct * 100}%</div>
            </div>
            <div className={'row'}>
              <div className='col-md-12'>
                <ReactSlider
                    value={10 - (client.modelBlendPct * 10)}
                    className="horizontal-slider"
                    thumbClassName="example-thumb"
                    trackClassName="example-track"
                    marks
                    markClassName="example-mark"
                    min={0}
                    max={10}
                    onChange={this.handleUpdateBlend}
                    renderThumb={(props, state) => {
                      return (
                      <div {...props}>
                        <div style={{width:'100%',textAlign:'center', marginTop:'2px'}}>
                        <div style={{display:'inline-block',marginRight:'10px'}}>
                          <FontAwesomeIcon color="#ACBCC9" icon="chevron-left" size="lg"/>
                        </div>
                        <div style={{display:'inline-block'}}>
                          <FontAwesomeIcon color="#EBEBEB" icon="grip-lines-vertical" size="lg"/>
                        </div>
                        <div style={{display:'inline-block',marginLeft:'10px'}}>
                          <FontAwesomeIcon color="#ACBCC9" icon="chevron-right" size="lg"/>
                        </div>
                        </div>
                      </div>
                    )}
                    }
                />
              </div>
            </div>
            <div className={'row'}>
              <div className={`col-md-6 ${s.sliderFootLeft}`}>% of {client.firstName}'s Current Portfolio<br />to keep intact</div>
              <div className={`col-md-6 ${s.sliderFootRight}`}>% WisdomTree<br />Models to blend in</div>
            </div>
          </div>
        </div>
        <div className="row" style={{ marginTop: '60px' }}>
          <div className={`col-md-12`} style={{ textAlign: 'center' }}>
            <div className={s.saveButton} onClick={this.saveClient}>SAVE</div>
            <div className={s.cancelButton} onClick={this.resetClient}>CANCEL</div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    token: state.params.token,
    advisorEmail: state.params.advisorEmail,
  };
}

export default connect(mapStateToProps, {
  saveClient,
  setEditMode,
})(Step3);




// WEBPACK FOOTER //
// ./src/components/AdvisorMode/Step3.js